import { AlertCircle } from "lucide-react";

/** Clean inline form-error banner — used instead of a toast so the error
 * sits right next to what the user just submitted. */
export function FormError({ message }: { message: string | null | undefined }) {
  if (!message) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3.5 py-2.5 text-sm text-red-600">
      <AlertCircle size={16} className="mt-0.5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
